import React from "react";
import { useMedia } from "react-use";
import { Text, mediaQuery } from "@hubble/web";
import type { BodyTextSize } from "@hubble/web/dist/esm/components/Text/BodyText";
import Link from "components/parts/NextLink";
import { RiskBannerContentWrapper, RiskBannerWrapper } from "../Wrappers";

type ESRiskBannerProps = {
  id?: string;
};

const ESRiskBanner = ({ id }: ESRiskBannerProps) => {
  const isMobileScreen = useMedia(mediaQuery.mobileXsDown);

  const riskStyleMobileProps = isMobileScreen
    ? {
        lineHeight: "17px",
        size: "xs" as BodyTextSize
      }
    : { size: "xs" as BodyTextSize };

  return (
    <RiskBannerWrapper id={id}>
      <RiskBannerContentWrapper>
        <Text.Body marketing {...riskStyleMobileProps}>
          La inversión en criptoactivos no está regulada, puede no ser adecuada
          para inversores minoristas y perderse la totalidad del importe
          invertido. Es importante leer y comprender los riesgos de esta
          inversión que se explican detalladamente&nbsp;
          <Text.Link bold as={Link} href="legal/spain-disclaimers">
            en esta ubicación.
          </Text.Link>
        </Text.Body>
      </RiskBannerContentWrapper>
    </RiskBannerWrapper>
  );
};

export default ESRiskBanner;
